let task

export default {
    onUnload () {
        task && clearTimeout(task)
    },
    methods: {
        checkSubPage () {
            const { sub_page } = this.$route.query
            if (sub_page) {
                task = setTimeout(() => {
                    wx.navigateTo({
                        url: `${decodeURIComponent(sub_page)}&detailParam=${this.getBuildingParams()}`
                    })
                }, 800)
            }
        },
        getBuildingParams () {
            const { building_id, house_id } = this.$route.query
            let detailParam = `building_id=${building_id}`
            if (house_id) {
                detailParam += `&house_id=${house_id || ''}`
            }
            return encodeURIComponent(detailParam)
        },
        goSubPagePath (path) {
            this.$router.push({
                path: `${path}&detailParam=${this.getBuildingParams()}`
            })
        }
    }
}
